(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["__CUSTOM__mega-menu-push-panel"] && !Shopify.designMode) return;
  try {
    // HORIZON MODIFICATION: mega menu push image hover swap.
  // Pure visibility toggling between panels that were server-rendered by
  // __CUSTOM__mega-menu-push-panel.liquid — never fetches data.
  // Shopify deduplicates javascript blocks across renders, so this runs once.
  (() => {
    if (window.__megaPushHoverInit) return;
    window.__megaPushHoverInit = true;

    const PANEL_SELECTOR = '.mega-menu__content[data-push-for], .mega-menu__content[data-push-default]';

    const activate = (grid, handle) => {
      const panels = grid.querySelectorAll(PANEL_SELECTOR);
      if (!panels.length) return;

      let target = null;
      if (handle) {
        target = grid.querySelector(`.mega-menu__content[data-push-for="${CSS.escape(handle)}"]`);
      }
      if (!target) {
        target = grid.querySelector('.mega-menu__content[data-push-default]');
      }

      for (const panel of panels) {
        panel.hidden = panel !== target;
      }
    };

    // Hovering or focusing a second-level link shows its panel when it has
    // one, otherwise the default panel.
    const onEnter = (event) => {
      const element = event.target instanceof Element ? event.target : null;
      const link = element?.closest('.mega-menu__list .mega-menu__link');
      if (!link) return;

      const grid = link.closest('.mega-menu__grid');
      if (grid) activate(grid, link.dataset.pushTarget || null);
    };

    document.addEventListener('pointerover', onEnter);
    document.addEventListener('focusin', onEnter);

    // Leaving the mega menu grid entirely restores the default panel.
    document.addEventListener('pointerout', (event) => {
      const element = event.target instanceof Element ? event.target : null;
      const grid = element?.closest('.mega-menu__grid');
      if (!grid) return;

      const related = event.relatedTarget;
      if (related instanceof Node && grid.contains(related)) return;

      activate(grid, null);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
